<h2 mat-dialog-title>{{ 'MEETING_SCHEDULER.MEETING_LIST.TEAM_MEMBERS' | translate }}</h2>
<mat-dialog-content>
  <glxy-form-field prefixIcon="search">
    <input matInput [placeholder]="'MEETING_SCHEDULER.MEETING_LIST.SEARCH' | translate" [formControl]="searchControl" />
  </glxy-form-field>
  <div class="checkbox-list">
    <glxy-checkbox [ngModel]="isAllSelected()" (ngModelChange)="onSelectAllChecked($event)">
      {{ 'MEETING_SCHEDULER.MEETING_LIST.SELECT_ALL' | translate }}
    </glxy-checkbox>
    @for (member of filteredMembers(); track member.userId) {
      <glxy-checkbox [ngModel]="isSelected(member.userId)" (ngModelChange)="onMemberChecked(member.userId, $event)">
        {{ member.displayName }}
      </glxy-checkbox>
    }
  </div>
  @if (isEmpty()) {
    <glxy-error>{{ 'MEETING_SCHEDULER.MEETING_LIST.MIN_ONE_USER_ERROR' | translate }}</glxy-error>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{ 'MEETING_SCHEDULER.MEETING_LIST.CANCEL' | translate }}</button>
  <button mat-flat-button color="primary" [disabled]="!hasChanges() || isEmpty()" (click)="apply()">
    {{ 'MEETING_SCHEDULER.MEETING_LIST.APPLY' | translate }}
  </button>
</mat-dialog-actions>
